import { BodyText, Button, Flex, Strong } from '@utilitywarehouse/hearth-react';

import { Dialog, DialogActions, DialogID } from '@components/Dialog';

interface PaperBillingModalProps {
  dialogId: DialogID;
  energyOnly: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PaperBillingModal = ({
  dialogId,
  energyOnly,
  onClose,
  onConfirm,
}: PaperBillingModalProps) => (
  <Dialog
    id={dialogId}
    heading={
      energyOnly
        ? 'Are you sure you want paper bills?'
        : 'Paper bills will cost you £4 a month'
    }
    hideCloseButton
    preventDismiss
    data-testid="paperBillingModal"
  >
    <Flex direction="column" gap="300">
      {energyOnly ? (
        <BodyText>
          If you don't provide an email address, we'll send your monthly bill in
          the post to your address. If you add any more of our services, you'll
          be charged <Strong>£4 a month</Strong> for paper bills.
        </BodyText>
      ) : (
        <BodyText>
          If you don't provide an email address, we'll send your monthly bill in
          the post to your address and you'll be charged{' '}
          <Strong>£4 a month</Strong> for paper bills.
        </BodyText>
      )}
      <BodyText>
        If possible, please enter an email address so we can send your bills in
        the most convenient and environmentally-friendly way. You'll be able to
        download and view them free of charge.
      </BodyText>
    </Flex>
    <DialogActions>
      <Button
        type="button"
        onClick={onClose}
        variant="solid"
        data-testid="paperBillingModalClose"
      >
        Enter email address
      </Button>
      <Button
        type="button"
        variant="outline"
        onClick={onConfirm}
        data-testid="paperBillingModalConfirm"
      >
        Confirm order without email
      </Button>
    </DialogActions>
  </Dialog>
);

export type { PaperBillingModalProps };
export { PaperBillingModal };
